import {Component, OnInit} from '@angular/core';
import {AuthService, BlockAbstractComponent, CacheService, ParserService} from '@gallaghercp/core-frontend';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {polyfill as smoothScrollPolyFill} from 'smoothscroll-polyfill'; // Polyfill required for Safari and iOS.

@Component({
    standalone: false,
    selector: 'core-block-benefits-menu',
    templateUrl: './block-benefits-menu.component.html',
})

export class BlockBenefitsMenuComponent extends BlockAbstractComponent implements OnInit {
    currentIndex: number = 0;
    categories$!: Observable<any>;
    isButtonHidden: boolean = false;
    filteredCategories?: any[];

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected cache: CacheService,
    ) {
        super(
            parser,
            auth
        );

        smoothScrollPolyFill();
    }

    override ngOnInit() {
        super.ngOnInit();
        this._getCategories();
    }

    private _getCategories() {
        this.categories$ = this.cache.getListThroughCache('page-categories').pipe(
            map((categories: any) => {
                this.filteredCategories = categories.filter((category: { pageCategories: string | any[]; }) => category.pageCategories.length > 0);
                const showAllPages: any[] = [];

                this.filteredCategories!.filter(category => {
                    category.pageCategories.slice(0, 3).map((pageCategory: { categoryId: any; categoryName: any; }) => {
                        pageCategory.categoryId = category.id;
                        pageCategory.categoryName = category.name;

                        showAllPages.push(pageCategory);
                    });
                });

                this.filteredCategories!.unshift({
                    id: 0,
                    name: 'Show all',
                    pageCategories: showAllPages
                });

                return this.filteredCategories;
            })
        );
    }

    public showAllCategories() {
        const element = document.getElementById('anchor-benefits');
        if (element) {
            const headerOffset = 20;
            const elementPosition = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
            const offsetPosition = elementPosition - headerOffset;

            this.categories$ = this.cache.getListThroughCache('page-categories').pipe(
                map((categories: any) => {
                    const filteredCategories = categories.filter((category: { pageCategories: string | any[]; }) => category.pageCategories.length > 0);
                    const showAllPages: any[] = [];
                    filteredCategories.filter((category: { id: number; pageCategories: any[]; name: any; }) => {
                        if (category.id !== 0) {
                            category.pageCategories.map(pageCategory => {
                                pageCategory.categoryId = category.id;
                                pageCategory.categoryName = category.name;
                                showAllPages.push(pageCategory);
                            });
                        }
                    });

                    this.filteredCategories![0].pageCategories = showAllPages;
                    return this.filteredCategories;
                })
            );

            this.isButtonHidden = true;

            this.currentIndex = 0;

            window.scrollTo({
                behavior: 'smooth',
                top: offsetPosition
            });
        }
    }

    public onChange(index: number) {
        if (this.currentIndex !== index) {
            this.currentIndex = index;
        }
    }

}
